import { Link } from 'react-router-dom';
import { InfoTip } from '@/components/Help/InfoTip';
import type { HelpTip } from '@/docs/tips/types';

interface TitleSectionProps {
  title: string;
  viewText: string;
  viewLinkTo: string;
  /** "i" icon explaining the block. */
  infoTip?: HelpTip;
}

export const TitleSection = ({
  title,
  viewText,
  viewLinkTo,
  infoTip,
}: TitleSectionProps) => {
  return (
    <div className="flex flex-1 flex-wrap justify-between gap-5">
      <div className="flex flex-1 items-center gap-1.5 text-md font-medium">
        {title}
        {infoTip && <InfoTip tip={infoTip} />}
      </div>
      <Link to={viewLinkTo} className="text-md font-medium underline">
        {viewText}
      </Link>
    </div>
  );
};
